import { createEntityAdapter } from '@reduxjs/toolkit';

import type { PhotoUpload } from './photos.types';

const photosAdapter = createEntityAdapter<PhotoUpload>({
  sortComparer: (a, b) => a.sort_index - b.sort_index,
});

export default photosAdapter;
